import { ArrowLeftIcon } from "@heroicons/react/20/solid";

import { Link, Outlet } from "react-router-dom";

import Navigation from "./Navigation";

export default function Inbox() {
  return (
    <main className="overflow-hidden h-full" style={{ height: "100vh" }}>
      <div className="grid w-full h-full grid-cols-two-col-app-grid border">
        <div className="pt-4 h-full flex flex-col">
          <div className="px-4 mb-8 flex-1 ">
            <Link to="/">
              <button className="p-2 bg-white rounded-full">
                <ArrowLeftIcon className="w-6" />
              </button>
            </Link>

            <Navigation />
          </div>
        </div>
        <div
          className="overflow-scroll  px-4 py-4 border-l border-gray-200"
          style={{ maxHeight: "100%", scrollbarWidth: 0 }}
        >
          <div
            className="bg-white px-6 pt-2 pb-10 rounded-md h-full"
            style={{ minHeight: "60vh" }}
          >
            <Outlet />
          </div>
        </div>
      </div>
    </main>
  );
}
